module.exports = __webpack_public_path__ + "img/g5.f40832a2.jpg";